/* unplugin-vue-components disabled */import script from "./ToolsBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToolsBar.vue?vue&type=script&lang=ts&setup=true"

import "./ToolsBar.vue?vue&type=style&index=0&id=64540747&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ZhongGuan\\Project\\zhong-guan-lh\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64540747"]])

export default __exports__